/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MfaRegistrationStatus
 */
export interface MfaRegistrationStatus {
    /**
     * 
     * @type {MfaRegistrationStatusStatusEnum}
     * @memberof MfaRegistrationStatus
     */
    status: MfaRegistrationStatusStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MfaRegistrationStatus
     */
    required: boolean;
}

/**
* @export
* @enum {string}
*/
export enum MfaRegistrationStatusStatusEnum {
    NONE = 'NONE',
    COMPLETE = 'COMPLETE',
    FEATURE_NOT_ENABLED = 'FEATURE_NOT_ENABLED'
}


/**
 * Check if a given object implements the MfaRegistrationStatus interface.
 */
export function instanceOfMfaRegistrationStatus(value: object): value is MfaRegistrationStatus {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function MfaRegistrationStatusFromJSON(json: any): MfaRegistrationStatus {
    return MfaRegistrationStatusFromJSONTyped(json, false);
}

export function MfaRegistrationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): MfaRegistrationStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'required': json['required'],
    };
}

export function MfaRegistrationStatusToJSON(json: any): MfaRegistrationStatus {
    return MfaRegistrationStatusToJSONTyped(json, false);
}

export function MfaRegistrationStatusToJSONTyped(value?: MfaRegistrationStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'required': value['required'],
    };
}

